import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import HeaderContainer from "../shared/HeaderContainer";
import LinkButton from "../shared/LinkButton";
import HeaderLogo from "../shared/HeaderLogo";
import StyledNav from "../shared/StyledNav";
import SmallLink from "../shared/SmallLink";
import DropdownLink from "./DropdownLink";

import Modal from "../../Pardot/Modal";

import theme from "../../../styles/theme";
import PardotForm from "../../Pardot/PardotForm";

const DesktopHeaderContainer = styled(HeaderContainer)`
  display: none;
  font-family: --fonts-sans;
  ${() => {
    return theme.media.desktopUp`
      display: flex;
  `}};
`;

const DesktopNav = ({ headerData }) => {
  const [displayNav, setDisplayNav] = React.useState(false);
  const navWrapper = useRef(null);
  const modalRef = useRef(null);


  useEffect(() => {
    setDisplayNav(true);
  }, [])

  return (
    <div data-nav-wrapper className={"desktop_only"} style={{transition: 'opacity .15s', minHeight: '80px', opacity: displayNav ? '1' : '0'}}>
      <style>{`
      .desktop_only {display: none;}
      @media only screen and (min-width: 800px) {
        .desktop_only {display: block;}
      }`}</style>
      <script dangerouslySetInnerHTML={{__html: `setTimeout(() => {document.querySelector('[data-nav-wrapper').style.opacity = '1'}, 300)`}}></script>
      <DesktopHeaderContainer>
        <HeaderLogo />
        <StyledNav>
          {headerData.links.map(link => {
            if (link.type === "dropdownLink") {
              return (
                <DropdownLink key={link.label} dropDownContent={link}>
                  {link.label}
                </DropdownLink>
              );
            }
            return (
              <SmallLink key={link.label} href={link.url}>
                {link.label}
              </SmallLink>
            );
          })}
        </StyledNav>
        {headerData.buttons.map(button => {
          if (button.formModal) {
            return (<>
              <LinkButton
                onClick={(e) => {
                  modalRef.current.openModal();
                  e.preventDefault();
                }}
                key={`button_${button.label}`}
                label={button.label}
                href={button.url}
                buttonType={button.type}
                calendly={button.calendly}
                hidden={button.hidden}
              />

              <Modal style={{marginTop: '-300px'}} ref={modalRef}>
                <h2 style={{fontFamily: 'Grenette', fontSize: '36px', fontWeight: 400, letterSpacing: '-1.12px', lineHeight: '47px', marginBottom: '10px'}}>Try Mode for free</h2>
                <PardotForm config={JSON.stringify(button.formModal)} />
              </Modal>
            </>);
          } else {
            return (
              <LinkButton
                key={`button_${button.label}`}
                label={button.label}
                href={button.url}
                buttonType={button.type}
                calendly={button.calendly}
                hidden={button.hidden}
              />
            );
          }
        })}
      </DesktopHeaderContainer>
    </div>
  );
};

export default DesktopNav;
